<template>
  <div class="StockCategory bc-white pt7 text-left" v-title data-title="库虾行话">
    <div class="text-center pb7">
      <van-button @click="back" class="btn-common" type="info" plain style="">返 回</van-button>
      <van-button @click="edit()" class="btn-common" type="info" style="margin-left: 10px;">添加行话</van-button>
    </div>
    <van-list
      v-model="loading"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      :finished-text="records.length > 10 ? '没有更多了' :''"
      @load="loadMore"
    >
      <div v-for="(rc) in records" :key="rc.id"
        @click="edit(rc)"
        class="row align-items-center records-item records-line"
      >
        <div class="flex-1">
          <div v-for="(h) in heads" :key="h.field" class="pt3 row align-items-baseline">
            <span class="record-label fc-less">{{h.title}}</span>
            <span class="flex-1">
              <template v-if="h.multi">
                <div v-for="(lst) in rc[h.field]" :key="lst.mobile">
                    {{lst.name}} {{lst.mobile}}
                </div>
              </template>
              <template v-else>{{rc[h.field]}}</template>
            </span>
          </div>
        </div>
        <van-icon @click="edit(rc)" class="fc-less" name="arrow" />
        <!-- <van-icon class="fs10" name="records" />
        <van-icon class="fs10" name="delete" /> -->
      </div>
    </van-list>
    <!-- 新增/编辑 -->
    <van-popup
      v-model="editShow"
      position="bottom"
    >
      <div class="pl5 pr5 pt10 pb10">
        <div class="text-center pb5">新增/编辑库虾行话</div>
        <div class="row pt3" :class="h.type==='upload'?'align-items-start':'align-items-baseline'" v-for="h in heads" :key="h.field">
          <div class="edit-label fc-less fs4">{{h.title}}</div>
          <div v-if="h.multi" class="flex-1">
            <div class="row align-items-center" :class="mdindex===0?'':'pt2'"
              v-for="(md, mdindex) in editItem[h.field]"
              :key="mdindex">
              <van-field
                class="col-8"
                v-model="md.name"
                clearable
                placeholder="称呼"
              />
              <van-field
                class="flex-1 ml2"
                v-model="md.mobile"
                clearable
                placeholder="号码"
              />
              <van-icon v-if="mdindex + 1 === editItem[h.field].length"
                @click="addMulti(h.field)" name="add-o" size="20px" class="ml1"/>
              <van-icon v-else
                @click="removeMulti(h.field, mdindex)" name="close" size="20px" class="ml1 fc-danger"/>
            </div>
          </div>
          <div v-else class="flex-1">
            <van-field
              v-model="editItem[h.field]"
              clearable
              :placeholder="'请输入'+h.title"
            />
          </div>
        </div>
        <div class="text-center pt10">
          <van-button @click="close()" class="btn-common" type="info" plain style="">关 闭</van-button>
          <van-button @click="save()" class="btn-common" type="info" style="margin-left: 10px;">保存行话</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { sendRequest, getStockCategoryList, saveStockCategory } from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';

export default Vue.extend({
  name: 'StockCategory',
  components: {},
  data() {
    return {
      loading: false,
      isAdmin: storage.local.get('type') === 1, // 1 管理员 2 报价商 3 测试 4 生产的测试用户
      error: false,
      finished: false,
      size: 20,
      current: 0,
      total: 1,
      pages: 1,
      hasNext: true,
      records: [],
      params: {},
      heads: [
        { title: '库虾行话', field: 'name' },
        {
          title: '行话解释', field: 'describe',
        },
      ],
      totalCount: 0,
      editShow: false,
      editItem: {},
    };
  },
  methods: {
    save() {
      const params = JSON.parse(JSON.stringify(this.editItem));
      sendRequest(saveStockCategory, params).then(() => {
        this.close();
        // this.records.push(this.editItem);
        this.getStockCategory();
      }).catch((e) => {
        this.$dialog.alert({
          message: `${e.message}`,
        });
      });
    },
    close() {
      this.editShow = false;
    },
    edit(item = {}) {
      this.editShow = true;
      this.editItem = item;
    },
    addMulti(filed = '') {
      const list = this.editItem[filed] || [];
      list.push({
        name: '',
        mobile: '',
      });
      this.$set(this.editItem, filed, list);
    },
    removeMulti(filed = '', index) {
      const list = this.editItem[filed] || [];
      list.splice(index, 1);
      this.$set(this.editItem, filed, list);
    },
    loadMore() {
      if (this.pages <= this.current) {
        return;
      }
      this.getStockCategory(this.current + 1);
    },
    getStockCategory(page = 1) {
      this.loading = true;
      sendRequest(getStockCategoryList, {
        current: page,
        size: this.size,
      }).then((res) => {
        console.log(res);
        const {
          total = 1, records = [], pages = 1,
        } = res;
        // const rds = records.map(rd => Object.assign({}, rd, {
        //   concatInfo: JSON.parse(rd.concatInfo || null),
        // }));
        const rds = records;
        if (page === 1) {
          this.records = rds || [];
        } else {
          this.records = this.records.concat(rds || []);
        }
        this.total = total;
        this.pages = pages;
        this.current = page;
        if ((rds || []).length < this.size || this.records.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.error = false;
      }).catch((e) => {
        this.$dialog.alert({
          message: `${e.message}`,
        });
        this.error = true;
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    back() {
      this.$router.push('/stock/info/home');
    },
  },
  created() {
    this.getStockCategory();
  },
});
</script>
<style scoped>
  .StockCategory {
    min-height: 100vh;
    padding-left: 5px;
    padding-right: 5px;
  }
  .StockCategory .required-box {
    width: 90px;
  }
  .StockCategory >>> .records-item {
    background-color: #ffffff;
    /* margin-top: 10px; */
    padding: 2px 0 10px 0;
    border-top: 1px solid #c7c1c1;
    /* margin-top: 10px; */
    /* border-radius: 6px; */
  }
  .StockCategory .record-label {
    width: 100px;
    padding-left: 10px;
  }
  .StockCategory .record-list {
    /* border-radius: 6px; */
    padding: 2px 4px;
    border: 1px solid #1989fa;
  }
  .StockCategory .edit-input {
    width: 100%;
    border: 1px solid #b1aeae;
    border-radius: 4px;
    padding: 3px 4px;
    /* height: 38px; */
  }
  .StockCategory .edit-label {
    width: 100px;
    padding-right: 5px;
  }
</style>
